export enum Features {
  liv = 'liv',
  myWorld = 'mm'
}
